<template>
  <div class="custom-selector-v2">

    <div class="application-form-input__col" data-v-085085c4="">
      <div
          class="custom-selector-v2__title"
          v-if="title != null"
          :class="{'custom-selector-v2__invalid': !inputIsValid}">
        {{ title }}
      </div>
      <vue-select
          :key="refreshKey"
          ref="mySelector"
          class="custom-selector-v2__vue-select"
          v-model="myValue"
          :options="options"
          label-by="text"
          track-by="text"
          :placeholder="placeholder"
          :search-placeholder="searchPlaceholder"
          searchable
          clear-on-select
          close-on-select
          clear-on-close
          :min="1"
          @onmouseenter="openSelector"
          @mouseleave="closeSelector"
          @selected="selected"
      ></vue-select>
      <!--      @selected="selected"-->
    </div>
  </div>
</template>

<script>
import {onMounted, ref, watch} from "@vue/runtime-core";
import {computed} from "@vue/reactivity";
import VueNextSelect from "vue-next-select";

export default {
  name: "CustomSelectorV2",
  components: {
    'vue-select': VueNextSelect,
  },
  props: {
    'modelValue': String,
    'title': String,
    'placeholder': {
      type: String,
      default: null
    },
    'isValid': {
      type: Boolean,
      default: true
    },
    'options': {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue', 'selected', 'dynamic', 'changed'],
  setup(props, {emit}) {
    const myValue = ref(null)
    const mySelector = ref(null)
    let refreshKey = ref(0)

    onMounted(() => {
      myValue.value = props.modelValue
      // myOptions.value = props.options
    })

    const inputIsValid = computed(() => {
      return props.isValid
      // if (typeof props.isValid === 'undefined')
      //   return true
      // else {
      //   if (props.isValid)
      //     return true
      //   else
      //     return myValue.value !== null
      // }
    })

    const openSelector = () => {
      mySelector.value.focus()
    }

    const closeSelector = () => {
      mySelector.value.blur()
    }


    watch(() => props.modelValue, (newValue) => {
      // console.log('updating value with ' + newValue)
      // console.log('options: ' + props.options.length)
      myValue.value = newValue
      refreshKey.value += 1
      emit("dynamic")
    })

    watch(() => props.options, () => {
      refreshKey.value += 1
      emit("dynamic")
    })

    watch(myValue, () => {
      // console.log(myValue.value)
      emit("update:modelValue", myValue.value)
      emit("dynamic")
    })

    // watch(() => props.options, (newValue) => {
    //   console.log('watching options... ' + newValue.length)
    //   refreshKey.value += 1
    // })

    const reload = () => {
      // console.log('reload(): ' + props.modelValue)
      refreshKey.value += 1
    }

    const selected = (e) => {
      // console.log('selected:')
      // console.log(e)
      emit("changed")
      // if (typeof myValue.value !== 'undefined') {
      //   console.log(myValue.value)
      //   emit("update:modelValue", e.value)
      // }

    }

    const closed = () => {
      // console.log('blur: ' + myValue.value)
      // emit("update:modelValue", myValue.value)
    }

    const searchPlaceholder = computed(() => {
      if (myValue.value === undefined || myValue.value === null || props.options === null) {
        return ''
      } else {
        let found = ''
        props.options.forEach((option) => {
          if (option.value === myValue.value)
            found = option.text
        })
        return found
      }
    })

    return {
      searchPlaceholder,
      refreshKey,
      reload,
      selected,
      closed,
      myValue,
      mySelector,
      openSelector,
      closeSelector,
      inputIsValid
    }
  },
}
</script>

<style scoped>

</style>
